import Loading from '@/components/general/Loading';
import { useAuth } from '@/providers/SupabaseAuthProvider';

const SkeletonLoader = function ({ children }: { children: JSX.Element }): JSX.Element {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <Loading fullPage />;
  }

  return children;
};

export default SkeletonLoader;
